<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <okmenu-logo />
      <h2 class="brand-text text-primary ml-1">
        WiSHOP
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          Unauthorized 🔐
        </h2>
        <p class="mb-2">
          You don't have the right access permission for this view
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="isAuthenticated ? { name: 'admin:dashboard' } : { name: 'login'}"
        >
          Back to home
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BLink, BButton } from 'bootstrap-vue'
import OkmenuLogo from '@core/layouts/components/Logo.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    OkmenuLogo,
    BLink,
    BButton,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
